import { getCategoryHref } from '../../utils/common/category';
import { IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'ideaGeneratorType',
      analyticsName: 'idea_type',
      textLabel: 'Generate idea for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Blog',
        value: getCategoryHref(IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'ideaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'ideas_generator',
      placeholder: 'Try "quick salad dinner dish" or "marketing campaign for pet food"',
      textLabel: 'Describe the kind of idea you want',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
